document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header__desktop');
  const spacer = document.querySelector('.nav-secondary-spacer');
  const secondary = document.querySelector('.nav-secondary-menu');
  const third = document.querySelector('.nav-third-menu');
  const isHome = window.location.pathname === '/';
  let activeThirdHandle = null; // Track active 3rd level dropdown

  /* --- Hide dropdown navigation --- */
  function hideDropdown() {
    secondary.classList.remove('active');
    secondary.classList.add('fade-out');
    third.classList.remove('active');
    third.classList.add('fade-out');
    hideSpacer();
  }
  /* --- Show secondary spacer --- */
  function showSpacer() {
    if (!spacer) return;
    spacer.style.display = "block";
    requestAnimationFrame(() => {
      spacer.style.height = secondary.offsetHeight + "px";
    });
  }
  /* --- Hide secondary spacer --- */
  function hideSpacer() {
    if (!spacer) return;
    spacer.style.display = "none";
    spacer.style.height = "0px";
  }
  /* --- Reset level 1 active Link --- */
  function resetActiveLinks() {
    document.querySelectorAll('.nav-first-link.active-parent')
        .forEach(link => link.classList.remove('active-parent'));
    const pre = document.querySelector('.nav-first-link.preactive');
      if (pre) pre.classList.remove('preactive');
  }
  /* --- Set link 1 to 'Water' --- */
  function setWaterActive() {
    // Reset all active parents
    document.querySelectorAll('.nav-first-link.active-parent')
      .forEach(link => link.classList.remove('active-parent'));
    // Set water active
    const waterTopLink = document.querySelector('.first-nav-item[data-handle="water"] .nav-first-link');
    if (waterTopLink) {
      waterTopLink.classList.add('preactive');
    }
    // Show water links
    document.querySelectorAll('.nav-second-link').forEach(el => {
      const show = el.dataset.parent === 'water';
      el.style.display = show ? 'flex' : 'none';
      if (show) el.classList.add('fade-in');
      else el.classList.remove('fade-in');
    });
  }
  /* --- Homepage --- */
  function isHomepage() {
    showSpacer();
    secondary.classList.remove('fade-out');
    secondary.classList.add('active');
    setWaterActive();    
  }
  /* --- Any other page --- */
  function anyOtherPage() {
    hideDropdown();
  }
  /* --- Level 1 hover --- */
  function level1Hover(item) {
    third.classList.remove('active');
    third.classList.add('fade-out');
    resetActiveLinks();

    // Apply active styling
    const firstLink = item.querySelector('.nav-first-link');
    if (firstLink) firstLink.classList.add('active-parent');

    // Hide menu for level 1 links with no children
    const handle = item.dataset.handle;
    const hasChildren = document.querySelector(`.nav-second-link[data-parent='${handle}']`);
    if (!hasChildren && isHome && window.scrollY === 0) {
      return;
    }
    else if (!hasChildren) {
      hideDropdown();
      return;
    }
    else {
      document.querySelectorAll('.nav-second-link').forEach(el => {
        const show = el.dataset.parent === handle;
        if (show) {
          el.style.display = 'flex';
          requestAnimationFrame(() => {
            el.classList.add('fade-in');
          });
        } else {
          el.classList.remove('fade-in');
          el.style.display = 'none';
        }
      });
    }    
    // Homepage behaviour
    if (isHome) {
      if (document.documentElement.classList.contains('scrolled')) {
        secondary.classList.remove('fade-out');
        secondary.classList.add('active');
        hideSpacer();
        return;
      } 
      else {
        secondary.classList.remove('fade-out');
        secondary.classList.add('active');
        showSpacer();
        return;
      }
    }
    // Any other page
    else {
      if (window.scrollY === 0) {
        secondary.classList.remove('fade-out');
        secondary.classList.add('active');
        return;
      }
      if (window.scrollY > 0) {
        secondary.classList.remove('fade-out');
        secondary.classList.add('active');
        hideSpacer();
        return;
      } 
    }
  }
  /* --- Level 2 hover --- */
  function level2Hover(link) {
    const secondHandle = link.dataset.handle;
    level3Hover(secondHandle);
  }
  /* --- Level 3 hover --- */
  function level3Hover(secondHandle) {
    activeThirdHandle = secondHandle;
    const group = document.querySelector(`.nav-third-group[data-parent="${secondHandle}"]`);
    // No children
    if (!group) {
      third.classList.remove('active');
      third.classList.add('fade-out');
      setTimeout(() => {
        if (activeThirdHandle === secondHandle) {
          document.querySelectorAll('.nav-third-group').forEach(g => {
            g.style.display = 'none';
          });
        }
      }, 400);
      return;
    }
    // Hide all groups
    document.querySelectorAll('.nav-third-group').forEach(g => {
      g.style.display = 'none';
      g.querySelectorAll('.nav-third-heading, .nav-third-link')
        .forEach(el => el.classList.remove('fade-in'));
    });
    // If another hover happened during the hide loop, abort
    if (activeThirdHandle !== secondHandle) return;

    // Show menu + links
    third.classList.remove('fade-out');
    third.classList.add('active');
    group.style.display = 'flex';
    // Force reflow so opacity:0 is applied
    void group.offsetWidth;
    // Only fade-in if still the active hover
    if (activeThirdHandle === secondHandle) {
      group.querySelectorAll('.nav-third-heading, .nav-third-link')
        .forEach(el => el.classList.add('fade-in'));
    }
  }
  /* --- Header Hover --- */
  header.addEventListener('mouseleave', () => {
    third.classList.remove('active');
    // Homepage
    if (isHome) {
      // If at top
      if (!document.documentElement.classList.contains('scrolled')) {
        return;
      }
    } 
    // Any other page
    else {
      hideDropdown();
      resetActiveLinks();
      return;
    }
  });
  /* --- Level 1 event listener --- */
  document.querySelectorAll('.first-nav-item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      level1Hover(item);
    });
  });
  /* --- Level 2 event listener --- */
  document.querySelectorAll('.nav-second-link').forEach(link => {
    link.addEventListener('mouseenter', () => {
      level2Hover(link);
    });
  });
  /* --- Scroll event listener --- */
  window.addEventListener('scroll', () => {
    // 1. Scrolled (hide dropdown on every page)
    if (window.scrollY > 5) {
      document.documentElement.classList.add('scrolled');
      hideDropdown();
      resetActiveLinks();
      return;
    }
    // 2. At top - Homepage (show level 2)
    else if (window.scrollY === 0 && isHome) {
      document.documentElement.classList.remove('scrolled');
      isHomepage();
      return;
    }
    // 2. At top - Any page (hide dropdown)
    else if (window.scrollY === 0 && !isHome) {
      document.documentElement.classList.remove('scrolled');
      anyOtherPage();
      return;
    }
  });
  /* --- Dead links --- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.nav-third-heading[data-dead="true"]');
    if (link) {
      e.preventDefault();
    }
  });
  /* --- Run logic --- */
  if (isHome) {
    document.documentElement.classList.add('home');
    isHomepage();
    return;
  } 
  else if (!isHome) {
    hideDropdown();
    return;
  }
});